// import ErrorBoundary from "./ErrorBoundary";
import Layout from "./layout";

const App = () => <Layout />;

export default App;
